import React from 'react';
import {
  // Category icons
  Home, ShoppingCart, ShoppingBag, Car, Fuel, Train, Plane,
  Coffee, Utensils, Pizza, Wine, Beer,
  Dumbbell, Heart, Pill, Stethoscope,
  Tv, Music, Gamepad2, Film, BookOpen, Headphones,
  Shirt, Scissors,
  Wifi, Phone, Laptop, Monitor, Smartphone,
  GraduationCap, BookMarked,
  TrendingUp, Banknote, CreditCard, PiggyBank, Wallet, Receipt,
  Gift, PartyPopper, Baby,
  Maximize2, HelpCircle, Hash,
  Leaf, Sun, Moon, Flower2,
  Building, Briefcase, Globe,
  Zap, Droplets, Flame, Trash2,
  ArrowUpRight, ArrowDownRight, Check,
  Lamp, Star, Users, Video, Apple, HousePlug, PlugZap, Euro, ShoppingBasket,
  Coins, BrushCleaning, TreePalm, FerrisWheel, HeartPulse, Landmark, PersonStanding,
  // Transaction states
  BookCheck, Calendar, CalendarClock, CalendarDays, CalendarRange,
  Clock, History, Repeat, Inbox, AlertCircle,
  // Navigation & UI
  Settings, Plus, Search, Filter, X, ChevronDown, ChevronUp,
} from 'lucide-react';

const ICON_REGISTRY = {
  // Category icons
  Home, ShoppingCart, ShoppingBag, Car, Fuel, Train, Plane,
  Coffee, Utensils, Pizza, Wine, Beer,
  Dumbbell, Heart, Pill, Stethoscope,
  Tv, Music, Gamepad2, Film, BookOpen, Headphones,
  Shirt, Scissors,
  Wifi, Phone, Laptop, Monitor, Smartphone,
  GraduationCap, BookMarked,
  TrendingUp, Banknote, CreditCard, PiggyBank, Wallet, Receipt,
  Gift, PartyPopper, Baby,
  Maximize2, HelpCircle, Hash,
  Leaf, Sun, Moon, Flower2,
  Building, Briefcase, Globe,
  Zap, Droplets, Flame, Trash2,
  ArrowUpRight, ArrowDownRight, Check,
  Lamp, Star, Users, Video, Apple, HousePlug, PlugZap, Euro, ShoppingBasket,
  Coins, BrushCleaning, TreePalm, FerrisWheel, HeartPulse, Landmark, PersonStanding,
  // Transaction states
  BookCheck, Calendar, CalendarClock, CalendarDays, CalendarRange,
  Clock, History, Repeat, Inbox, AlertCircle,
  // Navigation & UI
  Settings, Plus, Search, Filter, X, ChevronDown, ChevronUp,
};

const CategoryIcon = ({ name, size = 18, className = '' }) => {
  const Icon = ICON_REGISTRY[name] || HelpCircle;
  return <Icon size={size} className={className} />;
};

export default CategoryIcon;
export { ICON_REGISTRY };
